import { render } from "./WorkspacePage.vue?vue&type=template&id=f365369e&scoped=true"
import script from "./WorkspacePage.vue?vue&type=script&lang=js"
export * from "./WorkspacePage.vue?vue&type=script&lang=js"

import "./WorkspacePage.vue?vue&type=style&index=0&id=f365369e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f365369e"]])

export default __exports__